// At the moment the API isn't properly configured
// This file will serve as a temporary repository of necessary changes
// When practicable, the overrides used here can be transferred into the API

const fieldUIOverrides = {
  visitortype_parent: {
    label: 'And your child is...',
  },
  enrolllevel: {
    list: [
      {
        value: 'undergraduate',
        label: 'Undergraduate',
      },
      {
        value: 'graduate',
        label: 'Graduate',
      },
    ],
  },
  major: {
    inputType: 'autocomplete',
  },
};

const listUIOverrides = {
  visitortype_parent: {
    label: 'And your child is...',
  },
  enrolllevel: {
    list: [
      {
        value: 'undergraduate',
        label: 'Undergraduate',
      },
      {
        value: 'graduate',
        label: 'Graduate',
      },
    ],
  },
};

const stepUIOverrides: any = {
  10: {
    animTitle: `REG_04`,
  },
  15: {
    animTitle: `REG_01`,
  },
  25: {
    animTitle: `REG_02`,
  },
  30: {
    animTitle: `REG_03`,
  },
  35: {
    animTitle: `REG_05`,
  },
  40: {
    animTitle: `REG_06`,
  },
  45: {
    animTitle: `REG_07`,
  },
  50: {
    animTitle: null,
  },
};

export { fieldUIOverrides, stepUIOverrides, listUIOverrides };
